import {Component, EventEmitter, Input, Output} from '@angular/core';
import {EdlForm} from '../../components/form-builder/models/edl-form.model';
import {EdlUserForm} from '../../model/edl-user-form.model';
import { StateService } from '@uirouter/angular';

@Component({
    templateUrl: './complete-user-form.component.html'
})
export class CompleteUserFormComponent {
    @Input() userFormDetails: { QuestionnaireDetails: EdlForm, UserForm: EdlUserForm, UserFormHistory:[any] };
    @Input() returnMasterId: string;
    @Input() returnDetailId: string;
    @Input() returnType: number;
    @Input() printMode: Boolean = false;
    @Input() masterComplete: Boolean = false;
    @Input() canClose: Boolean = true;

    @Output() onSubmissionComplete = new EventEmitter<{ success: boolean, isQuestionnaireComplete: boolean }>()

    constructor(
        private stateService: StateService
    ) {}

    submissionComplete = (result: { success: boolean, isQuestionnaireComplete: boolean }) => {
        this.onSubmissionComplete.emit(result);
    }

    close = () => {
        if (this.returnType == 1) { 
            this.stateService.go('authenticated.my-compliance-items.cycle', {
                cycleId: this.returnDetailId
            },
            {
                reload: 'authenticated.my-compliance-items.cycle'
            });
        }
        else {
            this.stateService.go('authenticated.requests.open-request-item', {
                requestId: this.returnMasterId,
                userRequestId: this.returnDetailId
            }, {
                reload: 'authenticated.requests.open-request-item'
            });
        }
    }
}